import { ExternalCourseModernizationStatus, type ListExternalCoursesInput } from "@axio/graphql/generated/graphql";
import { hasMinRole, UserRoleUI } from "../../../constants/rolesAndPermissions";

export type ModernizerFilter = "all" | "modernized" | "inProgress" | "notStarted";

export const EMPTY_COURSE_SUMMARY = {
  totalCourses: 0,
  modernized: 0,
  inProgress: 0,
  notStarted: 0,
};

export const EVALUATION_NO_RUBRIC_REASON = "Add and activate a ready rubric before evaluating courses.";

const MODERNIZATION_STATUS_BY_FILTER: Record<Exclude<ModernizerFilter, "all">, ExternalCourseModernizationStatus> = {
  modernized: ExternalCourseModernizationStatus.Modernized,
  inProgress: ExternalCourseModernizationStatus.InProgress,
  notStarted: ExternalCourseModernizationStatus.NotStarted,
};

export const canManageCourseModernizerRubric = (userRole: UserRoleUI) => hasMinRole(userRole, UserRoleUI.SCHOOL_ADMIN);

export const getModernizationStatusForFilter = (
  activeFilter: ModernizerFilter
): ListExternalCoursesInput["modernizationStatus"] =>
  activeFilter === "all" ? undefined : MODERNIZATION_STATUS_BY_FILTER[activeFilter];

export const buildListExternalCoursesInput = ({
  activeFilter,
  facultyFilter,
  isAdmin,
  page,
  pageSize,
  searchQuery,
  termFilter,
}: {
  activeFilter: ModernizerFilter;
  facultyFilter: string;
  isAdmin: boolean;
  page: number;
  pageSize: number;
  searchQuery: string;
  termFilter: string;
}): ListExternalCoursesInput => ({
  page,
  pageSize,
  searchQuery: searchQuery.trim() || undefined,
  facultyId: isAdmin && facultyFilter !== "all" ? facultyFilter : undefined,
  termLabel: termFilter !== "all" ? termFilter : undefined,
  modernizationStatus: getModernizationStatusForFilter(activeFilter),
});
